<template>
  <router-view />
</template>

<script>
export default {
  name: 'TheEmptyRouterView'
};
</script>
